export const QUERY_CACHE_PERIOD = {
  SHORT: 60 * 1000, // 1 minute
  MEDIUM: 5 * 60 * 1000, // 5 minutes
  LONG: 15 * 60 * 1000, // 15 minutes
  EXTENDED: 30 * 60 * 1000 // 30 minutes
};
